import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { CaseMetadata, CaseStatusType } from '@/api';

interface CaseState {
  caseId: string | null;
  fullProductType: string | null;
  caseMetadata: CaseMetadata | null;
  caseStatus: CaseStatusType | null;
}

const initialState: CaseState = {
  caseId: null,
  fullProductType: null,
  caseMetadata: null,
  caseStatus: null
};

const caseSlice = createSlice({
  name: 'case',
  initialState: initialState,
  reducers: {
    setCaseIdData: (state, action: PayloadAction<string | null>) => {
      state.caseId = action.payload;
    },
    setFullProductType: (state, action: PayloadAction<string | null>) => {
      state.fullProductType = action.payload;
    },
    setCaseMetadata: (state, action: PayloadAction<CaseMetadata | null>) => {
      state.caseMetadata = action.payload;
    },
    setCaseStatus: (state, action: PayloadAction<CaseStatusType | null>) => {
      state.caseStatus = action.payload;
    }
  }
});

export const { setCaseIdData, setFullProductType, setCaseMetadata, setCaseStatus } = caseSlice.actions;

export const selectCaseIdData = (state: RootState) => {
  return state.case.caseId;
};
export const selectFullProductType = (state: RootState) => {
  return state.case.fullProductType;
};
export const selectCaseMetadata = (state: RootState) => {
  return state.case.caseMetadata;
};
export const selectCaseStatus = (state: RootState) => {
  return state.case.caseStatus;
};

export const caseReducer = caseSlice.reducer;
